import { Col, Row } from "antd";
import type {
  DashboardActionsCardComponent,
  DashboardColumnComponent,
  DashboardLeafComponent,
  DashboardRowComponent,
  DashboardTableCardComponent,
  DashboardViewConfigurationResponse,
} from "@rumbledirect/types";
import { TableCardRenderer } from "./components/TableCardRenderer";
import { ActionsCardRenderer } from "./components/ActionsCardRenderer";

function renderLeafComponent(component: DashboardLeafComponent) {
  switch (component.type) {
    case "tableCard":
      return (
        <TableCardRenderer
          key={component.key}
          component={component as DashboardTableCardComponent}
        />
      );
    case "actionsCard":
      return (
        <ActionsCardRenderer
          key={component.key}
          component={component as DashboardActionsCardComponent}
        />
      );
    default:
      return null;
  }
}

function renderColumn(column: DashboardColumnComponent) {
  return (
    <Col key={column.key} span={column.span} xxl={column.xxl ?? undefined}>
      {column.components.map((component) => renderLeafComponent(component))}
    </Col>
  );
}

function renderRow(row: DashboardRowComponent) {
  return (
    <Row key={row.key} gutter={[16, 16]}>
      {row.columns.map((column) => renderColumn(column))}
    </Row>
  );
}

interface Props {
  config: DashboardViewConfigurationResponse;
}

export function DashboardView({ config }: Props) {
  if (config.type === "components") {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {config.components.map((row) => renderRow(row))}
      </div>
    );
  }

  if (config.type === "tabs") {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {config.tabs.map((tab) => (
          <div key={tab.key}>{tab.rows.map((row) => renderRow(row))}</div>
        ))}
      </div>
    );
  }

  return null;
}
